import React, { useState } from 'react';
import { Conversations } from '../../model';
import ExpandableBlock from '../ExpandableBlock';
import './ConversationSidebar.scss';

export interface ConversationSidebarProps {
  conversation: Conversations | null;
}

const ConversationSidebar: React.FC<ConversationSidebarProps> = ({
  conversation,
}) => {
  const [infoExpanded, setInfoExpanded] = useState(true);
  const [summaryExpanded, setSummaryExpanded] = useState(true);

  const formatSummary = (text: string) => {
    return text.replace(/\*\*(.*?)\*\*/g, '<b>\n$1</b>');
  };

  if (!conversation) return null;

  return (
    <div className="conversation-sidebar">
      <ExpandableBlock
        title="Metadata"
        expanded={infoExpanded}
        onToggle={() => setInfoExpanded(v => !v)}
        className="info-panel">
        <p>Channel type: {conversation.type}</p>
        {conversation.metadata && (
          <div className="info-details">
            <div>Failed attempts: {conversation.metadata.failedAttempts}</div>
            <div>Sentiment: {conversation.metadata.sentiment ?? '-'}</div>
          </div>
        )}
      </ExpandableBlock>

      {conversation.summary && (
        <ExpandableBlock
          title="Summary"
          expanded={summaryExpanded}
          onToggle={() => setSummaryExpanded(v => !v)}
          className="summary-panel">
          <div
            className="conversation-summary__ai-text"
            dangerouslySetInnerHTML={{
              __html: formatSummary(conversation.summary),
            }}
          />
        </ExpandableBlock>
      )}
    </div>
  );
};

export default ConversationSidebar;
